import { create } from "../../../common/utils/zustand_state_manager";
import { IComercialService } from "../../../features/comercial/data/services/comercial_service";
import { ComercialService } from "../../../features/comercial/data/services/comercial_service_impl";

/**
 * useComercialServices
 */

type State = {
  comercialService: IComercialService,
};

export const useComercialServices = create<State>((set, get) => ({
  comercialService: new ComercialService(),
}));